export function setBrowserStyleProperties(document, settings) {
  if (document.settings_id === settings._id || !settings) return;

  document.settings_id = settings._id;

  document.documentElement.style.setProperty("--highlightColor", settings.highlight_color, "important");
  document.documentElement.style.setProperty("--headerColor", settings.top_bar_color, "important");
  document.documentElement.style.setProperty("--headerTextColor", settings.top_bar_text_color, "important");
  document.documentElement.style.setProperty("--leftNavColor", settings.side_bar_color, "important");
  document.documentElement.style.setProperty("--leftNavActiveColor", settings.side_bar_shade_color, "important");
  document.documentElement.style.setProperty("--leftNavTextColor", settings.side_bar_text_color, "important");
  document.documentElement.style.setProperty("--leftNavActiveTextColor", settings.left_nav_active_text_color, "important");
  document.documentElement.style.setProperty("--backgroundColor", settings.background_color || "#fff", "important");
  document.documentElement.style.setProperty("--headerMenuActiveBgColor", settings.header_menu_active_bg_color || "#ffffff", "important");
  document.documentElement.style.setProperty("--headerMenuActiveTextColor", settings.header_menu_active_text_color || "#000000", "important");

  document.title = settings.site_name || settings.name || "";
  document.querySelector("meta[name='title']").setAttribute("content", settings.login_page_title);
  document.querySelector("meta[name='description']").setAttribute("content", settings.login_page_subtitle);

  const favicon = document.querySelector("link[rel*='icon']");
  const appleIcon = document.querySelector("link[rel*='apple-touch-icon']");
  const iconUrl = settings.image_favicon || settings.square_logo;
  const timestampedIconUrl = iconUrl ? `${iconUrl}?${Date.now()}` : "./assets/img/image_favicon-default.png";

  if (favicon) favicon.href = timestampedIconUrl;
  if (appleIcon) appleIcon.href = timestampedIconUrl;

  // if (settings.global_html) {
  //   const tempDiv = document.createElement("div");
  //   tempDiv.innerHTML = settings.global_html;

  //   // Inject each child node correctly
  //   Array.from(tempDiv.childNodes).forEach((node) => {
  //     if (node.tagName === "SCRIPT") {
  //       // Create a new script element
  //       const script = document.createElement("script");

  //       // Copy attributes
  //       for (let attr of node.attributes) {
  //         script.setAttribute(attr.name, attr.value);
  //       }

  //       // Copy inline script content
  //       if (node.textContent) {
  //         script.textContent = node.textContent;
  //       }

  //       document.body.appendChild(script);
  //     } else {
  //       document.body.appendChild(node);
  //     }
  //   });
  // }
}
